import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BankaTaksitBilgileri from "./pages/BankaTaksitBilgileri";
import DegisimIadeProseduru from "./pages/DegisimIadeProseduru";
import FirmaBilgiFormu from "./pages/FirmaBilgiFormu";
import Kvkk from "./pages/Kvkk";
import SportiveSahaGizlilikPolitikasi from "./pages/SportiveSahaGizlilikPolitikasi";
import "./App.css";

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/banka-taksit" element={<BankaTaksitBilgileri />} />
            <Route path="/degisim-iade" element={<DegisimIadeProseduru />} />
            <Route path="/kvkk" element={<Kvkk />} />
            <Route path="/firma-bilgi-formu" element={<FirmaBilgiFormu />} />
            <Route path="/sportivesaha-gizlilik-politikasi" element={<SportiveSahaGizlilikPolitikasi />} />
        </Routes>
    );
}

export default App;
